import Grid from "@mui/material/Grid2";
import { InsightMap } from "@/components/molecules";
import { LocationResult } from "@/types";
import React from "react";

interface MapViewProps {
  locations: LocationResult;
}

export const MapView: React.FC<MapViewProps> = ({ locations }) => {
  return (
    <Grid container size={12} spacing={2} flexGrow={1}>
      <InsightMap scores={locations} />
    </Grid>
  );
};

export default MapView;
